export default function enumKeys<O extends object, K extends keyof O = keyof O>(
  obj: O
): K[] {
  return Object.keys(obj).filter((k) => !Number.isNaN(k)) as K[]
}

export function enumKeyToLabel(key: string) {
  return key.split(/(?=[A-Z])/).join(' ')
}

export function enumValueToKeyLabel<O extends object>(value: string, obj: O) {
  let result = ''
  enumKeys(obj).forEach((key) => {
    if (obj[key] === value) {
      result = key as string
    }
  })
  return enumKeyToLabel(result)
}
